"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAccessList = void 0;
// (C) 2021-2023 GoodData Corporation
var react_1 = require("react");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var shareDialogMappers_1 = require("../../shareDialogMappers");
/**
 * @internal
 */
exports.useGetAccessList = function (props) {
    var sharedObjectRef = props.sharedObjectRef, currentUser = props.currentUser, onSuccess = props.onSuccess, onError = props.onError;
    var effectiveBackend = sdk_ui_1.useBackendStrict();
    var effectiveWorkspace = sdk_ui_1.useWorkspaceStrict();
    var promise = function () {
        return effectiveBackend.workspace(effectiveWorkspace).accessControl().getAccessList(sharedObjectRef);
    };
    var onSuccessCallBack = react_1.useCallback(function (result) {
        var grantees = result.map(function (item) { return shareDialogMappers_1.mapAccessGranteeDetailToGrantee(item, currentUser); });
        onSuccess(grantees);
    }, [currentUser, onSuccess]);
    sdk_ui_1.useCancelablePromise({ promise: promise, onError: onError, onSuccess: onSuccessCallBack }, [
        effectiveBackend,
        effectiveWorkspace,
        sharedObjectRef,
        onSuccessCallBack,
    ]);
};
//# sourceMappingURL=useGetAccessList.js.map